import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';

const ProductIdCreation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1">
        {t('ProductIdCreation.Title')}
      </Typography>
    </Box>
  );
};

export default ProductIdCreation;
